import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, InputMaskModule } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { EmpregoNaPistaSharedModule } from '../shared/emprego-na-pista-shared.module';

import { clinicaRouting } from './clinica.routing';

import { ClinicaService } from './clinica.service';
import { EnderecoService } from '../shared/services/endereco.service';

import { AnalisarCredenciamentoClinicaComponent } from './analisar-credenciamento-clinica/analisar-credenciamento-clinica.component';
import { CadastroClinicaFormComponent } from './cadastro-clinica-form/cadastro-clinica-form.component';
import { GerarRequerimentoClinicaComponent } from './gerar-requerimento-clinica/gerar-requerimento-clinica.component';
import { GerenciarClinicaComponent } from './gerenciar-clinica/gerenciar-clinica.component';
import { VisualizarClinicaComponent } from './visualizar-clinica/visualizar-clinica.component';
import { VisualizarEditaisClinicaComponent } from './visualizar-editais-clinica/visualizar-editais-clinica.component';
import { VisualizarHistoricoAnalisesClinicaComponent } from './visualizar-historico-clinica/visualizar-historico-clinica.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        clinicaRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, InputMaskModule,

        Ng2BRPipesModule,

        EmpregoNaPistaSharedModule
    ],
    providers: [ ClinicaService, EnderecoService ],
    declarations: [
        AnalisarCredenciamentoClinicaComponent,
        CadastroClinicaFormComponent,
        GerarRequerimentoClinicaComponent,
        GerenciarClinicaComponent,
        VisualizarClinicaComponent,
        VisualizarEditaisClinicaComponent,
        VisualizarHistoricoAnalisesClinicaComponent
    ],
})
export class ClinicaModule { }



// WEBPACK FOOTER //
// ./src/app/components/clinica/clinica.module.ts